export default __webpack_public_path__ + "static/media/31.1546ddbb.mp3";